import React from 'react';
import { Image as SemanticImage } from 'semantic-ui-react';
import styles from './styles.module.scss';

export const LargeImage = ({ src, alt }) => (
  <SemanticImage
    className={styles.image}
    centered
    src={src}
    alt={alt}
  /> 
);
